<div class="eval-block">
  <div class="eval-col">
    <p class="label">Social History Meeting Date</p>
    <p>{{ gridData?.shmDate }}</p>
  </div>
  <div class="eval-col">
    <p class="label">Status of Social History Package</p>
    <p>{{ gridData?.shpStatus }}</p>
  </div>
  <div class="eval-col">
    <p class="label">Consent for Initial Evaluation Given?</p>
    <p>{{ gridData?.consentIEGiven }}</p>
  </div>
</div>
<kendo-grid [data]="gridData?.evaluationList" [loading]="loading" scrollable="virtual"
  [kendoGridBinding]="gridData?.evaluationList" [pageable]="true" [pageSize]="50">
  <kendo-grid-column field="" title="" [headerClass]="'grid-header'" [autoSize]="columnDefinitions[0].autoSize"
    [width]="columnDefinitions[0].width">
    <ng-template kendoGridCellTemplate let-row>
      <button kendoButton #anchor [svgIcon]="actionIcon" (click)="loadActions($event, row)" fillMode="clear" size="none"
        title="Actions"></button>
      <kendo-contextmenu [target]="anchor" size="large" showOn="click">
        <ng-template kendoContextMenuTemplate>
          <app-custom-actions [studentDetails]="studentDetails" [evalRowDetails]="row" [evalActions]="evalActions"
            (requestExtensionDialog)="showRequestExtensionDialog$.next($event)" (scheduleMeetingAssessmentDialog)="
              showScheduleMeetingAssessmentDialog$.next($event)
            " (meetingType)="meetingType = $event" (meetingSk)="meetingSk = $event" (actionText)="actionText = $event"
            (isReSchedule)="isReSchedule = $event" (selectedEvalRowDetails)="selectedEvalRowDetails = $event">
          </app-custom-actions>
        </ng-template>
      </kendo-contextmenu>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="evaluationName" title="Assessments In Progress" [autoSize]="columnDefinitions[1].autoSize"
    [width]="columnDefinitions[1].width">
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      <p class="!k-m-0 k-white-space-normal">{{ row?.evaluationName }}</p>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="agencyName" title="Agency Name" [autoSize]="columnDefinitions[2].autoSize"
    [width]="columnDefinitions[2].width">
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      <p class="!k-m-0 k-white-space-normal">{{ row?.agencyName }}</p>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="evaluatorName" title="Evaluator Name" [autoSize]="columnDefinitions[3].autoSize"
    [width]="columnDefinitions[3].width">
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      {{ row?.evaluatorName }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="evaluatorType" title="Evaluator Type" [autoSize]="columnDefinitions[4].autoSize"
    [width]="columnDefinitions[4].width">
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      {{ row?.evaluatorType }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="dueDate" title="Evaluation Due Date" [autoSize]="columnDefinitions[5].autoSize"
    [width]="columnDefinitions[5].width">
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      {{ row?.dueDate | date : "MM/dd/yyyy" }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="evaluationStatus" title="Status" [autoSize]="columnDefinitions[6].autoSize"
    [width]="columnDefinitions[6].width">
    <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
      <p class="!k-m-0" [ngClass]="{
                'k-text-success': row?.evaluationStatus === 'Finalized',
                'k-text-primary': row?.evaluationStatus === 'Requested',
                'k-text-warning': row?.evaluationStatus === 'Pending Review',
                'k-text-error': !row?.evaluatorType && row?.evaluationStatus === 'NotStarted',
              }">
        {{
        !row?.providerSk &&
        row?.evaluationStatus === "Draft" &&
        row?.evaluatorType !== "Provided by Parent"
        ? "Pending Assignment"
        : row?.providerSk && row?.evaluationStatus === "NotStarted"
        ? "Pending Scheduling"
        : row?.evaluationStatus
        }}
      </p>
    </ng-template>
  </kendo-grid-column>

  <ng-template kendoGridNoRecordsTemplate>
    <div>
      <kendo-badge-container>
        <kendo-svg-icon [icon]="cloudIcon" size="large"></kendo-svg-icon>
        <kendo-badge position="inside" themeColor="error">
          <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
        </kendo-badge>
      </kendo-badge-container>
    </div>
    <div class="k-pt-2">There is no data to display.</div>
    <!-- TODO use the css library for styles -->
  </ng-template>
</kendo-grid>

<kendo-dialog *ngIf="showRequestExtensionDialog$ | async" (close)="showRequestExtensionDialog$.next(false)"
  class="shm-window" [maxWidth]="1900" [width]="700" [minHeight]="300"
  [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'">
  <app-request-extension [dueDate]="studentDetails?.dueDate" [evaluationName]="selectedEvalRowDetails?.evaluationName"
    [referralSk]="studentDetails.referralSK" [createExtension]="true"
    [evaluationSk]="selectedEvalRowDetails?.evaluationSk" (close)="showRequestExtensionDialog$.next(false)">
  </app-request-extension>
</kendo-dialog>

<kendo-dialog *ngIf="showScheduleMeetingAssessmentDialog$ | async"
  (close)="showScheduleMeetingAssessmentDialog$.next(false)" class="shm-window" [maxWidth]="1900" [width]="1200"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'">
  <app-assessment-schedule-meeting [studentDetails]="studentDetails" [evaluationDetails]="selectedEvalRowDetails"
    [actionText]="actionText" [nycIds]="studentDetails?.nycid" [meetingType]="meetingType" [meetingSk]="meetingSk"
    [assessmentSk]="selectedEvalRowDetails?.evaluationSk" [referralSk]="studentDetails.referralSK"
    (close)="showScheduleMeetingAssessmentDialog$.next(false)"
    [isReSchedule]="isReSchedule"></app-assessment-schedule-meeting>
</kendo-dialog>